"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var auth_1 = require("../auth");
var Authenticator_1 = require("./Authenticator");
var ChangePassword_1 = require("./ChangePassword");
var Home_1 = require("./Home");
var ForgotPassword_1 = require("./ForgotPassword");
var ResetPassword_1 = require("./ResetPassword");
var SignUp_1 = require("./SignUp");
var SignIn_1 = require("./SignIn");
var ConfirmSignUp_1 = require("./ConfirmSignUp");
var PrivateRoute = /** @class */ (function (_super) {
    __extends(PrivateRoute, _super);
    function PrivateRoute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isAuthenticated: false,
            loading: true
        };
        _this.unlisten = _this.props.history.listen(function () {
            _this.setState({ isAuthenticated: false });
        });
        return _this;
    }
    PrivateRoute.prototype.componentDidMount = function () {
        this.authenticate();
    };
    PrivateRoute.prototype.authenticate = function () {
        var _this = this;
        auth_1.InfoAuth.currentAuthenticatedUser()
            .then(function (user) {
            console.log('User ', user);
            _this.setState({ isAuthenticated: true, loading: false });
        })
            .catch(function () {
            _this.props.history.push('/auth');
        });
    };
    PrivateRoute.prototype.render = function () {
        var _a = this.props, Component = _a.component, rest = __rest(_a, ["component"]);
        var _b = this.state, isAuthenticated = _b.isAuthenticated, loading = _b.loading;
        if (loading) {
            return null;
        }
        return (React.createElement(react_router_dom_1.Route, __assign({}, rest, { render: function (props) {
                return isAuthenticated ? (React.createElement(Component, __assign({}, props))) : (React.createElement(react_router_dom_1.Redirect, { to: { pathname: '/auth1' } }));
            } })));
    };
    return PrivateRoute;
}(react_1.Component));
var ProtectedRoute = react_router_dom_1.withRouter(PrivateRoute);
var Routes = function (props) {
    return (React.createElement(react_router_dom_1.HashRouter, null,
        React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { exact: true, path: "/", component: function () { return React.createElement(Authenticator_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { path: "/login", component: function (props) { return (React.createElement(SignIn_1.default, __assign({}, props, { email: props.location.state && props.location.state.email }))); } }),
            React.createElement(react_router_dom_1.Route, { path: "/forgotPassword", component: function () { return React.createElement(ForgotPassword_1.default, __assign({}, props)); } }),
            React.createElement(react_router_dom_1.Route, { path: "/resetPassword", component: function (prop) { return (React.createElement(ResetPassword_1.default, __assign({}, props, { email: prop.location.state.email }))); } }),
            React.createElement(react_router_dom_1.Route, { path: "/signUp", component: function (prop) { return (React.createElement(SignUp_1.default, __assign({}, props, { showConfirmation: prop.location.state
                        ? prop.location.state.showConfirmation
                        : false, userName: prop.location.state
                        ? prop.location.state.userName
                        : '' }))); } }),
            React.createElement(react_router_dom_1.Route, { path: "/confirmSignUp", component: function (prop) { return (React.createElement(ConfirmSignUp_1.default, __assign({}, props, { email: prop.location.state.email, userId: prop.location.state.userId, showToast: prop.location.state.showToast ? true : false }))); } }),
            React.createElement(react_router_dom_1.Route, { path: "/changePassword", component: function (prop) { return (React.createElement(ChangePassword_1.default, __assign({}, props, { userName: prop.location.state.userName }))); } }),
            React.createElement(ProtectedRoute, { path: "/", component: Home_1.default }))));
};
exports.default = Routes;
//# sourceMappingURL=Router.js.map